export enum Periode {
  CARNAVAL = 'Carnaval',
  PRINTEMPS = 'Printemps',
  ETE = 'Eté',
  TOUSSAINT = 'Toussaint',
  NOEL_NA = 'Noël/Nouvel-An'
}

